import { Pipe, PipeTransform } from '@angular/core';
import { SuiviPrestation } from '../../models/suiviPrestation';

@Pipe({
	name: 'sortBySuiviPrestationDate'
})
export class SortBySuiviPrestationDatePipe implements PipeTransform {
	transform(
		array: Array<{ suivi: SuiviPrestation; employeeName: string }>,
		sortOrder = 'asc'
	): any[] {
		if (!Array.isArray(array) || array.length === 0) {
			return array;
		}

		return array.sort((a, b) => {
			const dateA = new Date(a.suivi.dateEntretien).getTime();
			const dateB = new Date(b.suivi.dateEntretien).getTime();

			return sortOrder === 'asc' ? dateA - dateB : dateB - dateA;
		});
	}
}
